'use strict';


Object.defineProperty(exports, "__esModule", {
  value: true
});


exports.FileManagerApp = function(){
	this.name = "";	
	this.success = null;
	this.error = null;
	this.contentsOptional = null;
	// 0 = json, image = 1
	this.fileType = 0;
	this.reader = null;
	this.fileEntry = null;
	this.dataToWrite = null;
	this.returnToURL = false;
	this.doNotCallSuccess = true;
	
this.getConfigFile = function (name, success, error, contentsOptional){
	this.resetAll();
	this.name = name + ".json";
	this.success = success;
	this.error = error;
	this.contentsOptional = contentsOptional;
	this.fileType = 0;
	// window.requestFileSystem(LocalFileSystem.PERSISTENT, 0, obj.manageFileEntry, obj.manageFileEntry);
	//console.log("configfunc", this.name);
	window.requestFileSystem(LocalFileSystem.PERSISTENT, 0, (fs) => this.manageFS(fs), (error) => this.manageError(error));
	/*window.requestFileSystem(LocalFileSystem.PERSISTENT, 0, function (fs) {
	console.log('file system open: ' + fs.name);
      fs.root.getFile(name + ".json", { create: true, exclusive: false }, function (fileEntry) {
        fileEntry.file(function(file) {
		  var reader = new FileReader();

          reader.onloadend = function(e) {
		    if (this.result === "" || this.result === undefined || this.result === null) {
				this.result = contentsOptional;
				writeFile(fileEntry, JSON.stringify(this.result));
			} else {
				this.result = JSON.parse(this.result);
			}
			success(this.result)				
          };
          reader.readAsText(file);
		}) 
        console.log("fileEntry is file?" + fileEntry.isFile.toString());
        // fileEntry.name == 'someFile.txt'
        // fileEntry.fullPath == '/someFile.txt'
        
 
    }, error);
 
  }, error);*/
}
this.saveConfigFile = function (name, content, success, error) {
	this.resetAll();
	this.name = name + ".json"
	this.success = success;
	this.error = error;
	this.fileType = 0;
	this.contentsOptional = new Blob([JSON.stringify(content)], { type: 'text/plain' });
	this.writingOp = true;
 	window.requestFileSystem(LocalFileSystem.PERSISTENT, 0, (fs) => this.manageFS(fs), (error) => this.manageError(error));
	
}
this.saveFileDocument = function (name, type, content, platform, success, error) {
	this.resetAll();
	this.name = name;
	this.success = success;
	this.error = error;
	this.fileType = 1;
	this.writingOp = true;
	var storageLocation = "";
	if(platform.toLowerCase() == "android"){
        storageLocation = 'file:///storage/emulated/0/';		
		storageLocation += "Download";		
	} else {
		storageLocation = cordova.file.documentsDirectory;		
	}
		
	if(content instanceof Blob) {
    this.contentsOptional = content;		
	}else{
    this.contentsOptional = new Blob([content], { type: type });		
	}
	window.resolveLocalFileSystemURL(storageLocation, (dir) => {
        dir.getFile(name, {create:true}, (file) => {
                file.createWriter((fileWriter) => {
                    fileWriter.write(this.contentsOptional);
                    //Download was succesfull
                    this.success(file.toURL(), this.name);
                }, (err) => {
                  // failed
                  this.error(err);
                  //console.log(err);
                });
        }, (err) => {
             this.error(err);
         });
      });  	
}
this.saveImageToGallery = function (name, type, content, platform, success, error) {
	this.resetAll();
	this.name = name;
	this.success = success;
	this.error = error;
	this.fileType = 1;
	this.writingOp = true;
	
    if(platform.toLowerCase() == "android"){
	if(content instanceof Blob) {
    this.contentsOptional = content;		
	}else{
    this.contentsOptional = new Blob([content], { type: type });		
	}
	var storageLocation = "";
        storageLocation = 'file:///storage/emulated/0/';		
		storageLocation += "Download";
	window.resolveLocalFileSystemURL(storageLocation, (dir) => {
        dir.getFile(name, {create:true}, (file) => {
                file.createWriter((fileWriter) => {
                    fileWriter.write(this.contentsOptional);
                    //Download was succesfull
                    this.success(file.toURL(), this.name);
                }, function(err){
                  // failed
                  this.error(err);
                  //console.log(err);
                });
        });
      }); 
  }else {
	  cordova.plugins.imagesaver.saveImageToGallery(content, true, (success) => {
			this.success();
		  }, (err) => {
			  this.error(err);
             //console.log(err);
			  });
  }   
}
this.getImageFromGallery = function (success, error) {
	this.resetAll();
	this.success = success;
	this.error = error;
	this.fileType = 1;
	this.returnToURL = true;	
    navigator.camera.getPicture((fileURI) => this.convertPath(fileURI), (error) => this.manageError(error), {destinationType: navigator.camera.DestinationType.FILE_URI, sourceType: navigator.camera.PictureSourceType.PHOTOLIBRARY, targetWidth: 1024, targetHeight: 768})
}
this.convertPath = function (fileURI) {
       window.resolveLocalFileSystemURL(
         fileURI,
         (fileEntry) => this.manageFileEntry(fileEntry)
    )
}
this.saveImage = function (name, type, content, success, error) {
	this.resetAll();
	this.name = name;
	this.success = success;
	this.error = error;
	this.fileType = 1;
	this.writingOp = true;
	if(content instanceof Blob) {
    this.contentsOptional = content;		
	}else{
    this.contentsOptional = new Blob([content], { type: type });		
	}
	window.requestFileSystem(LocalFileSystem.PERSISTENT, 0, (fs) => this.manageFS(fs), (error) => this.manageError(error));

}
this.readImage = function (name, success, error) {
	this.resetAll();
	this.name = name;
	this.success = success;
	this.error = error;
	this.fileType = 1;
	this.returnToURL = true;	
	window.requestFileSystem(LocalFileSystem.PERSISTENT, 0, (fs) => this.manageFS(fs), (error) => this.manageError(error));
}
this.copyImage = function (name, success, error) {
	
}
this.manageFileReader = function (e) {
		//console.log("filereader", this.name);
		var finalResult = this.reader.result;
		    if ((finalResult === "" || finalResult === undefined || finalResult === null) && this.contentsOptional != null) {
				//console.log("empty file writting", this.name);
				finalResult = this.contentsOptional;
				this.writeFile(this.fileEntry, JSON.stringify(finalResult), true);
			} else {
				////console.log("reading from file", this.name);
				if(this.fileType == 0){					
				finalResult = JSON.parse(finalResult);
				}else{
				finalResult = finalResult;
				}
			}
			if(this.success!=null && this.success!=undefined){
			this.success(finalResult, this.name);				
			}	
}
this.manageFile = function (file) {
		//console.log("file", this.name);
	this.reader = new FileReader();

    this.reader.onloadend = (e) => this.manageFileReader(e);
    if(this.fileType == 0){
    this.reader.readAsText(file);	
	}else {
	this.reader.readAsArrayBuffer(file);
	}
}
this.manageFileEntry = function (fileEntry) {
		//console.log("fileentry", this.name);
	this.fileEntry = fileEntry;
	if(this.returnToURL == true){
	if(this.success!=null && this.success!=undefined){			
	this.success(this.fileEntry.toURL(), this.name);	
	}
	}else if(this.writingOp == true){
	this.writeFile(this.fileEntry, this.contentsOptional);
	}else{	
	fileEntry.file((file) => this.manageFile(file));
	}
}
this.manageFS = function (fs) {
		//console.log("managefs", this.name);
	fs.root.getFile(this.name, { create: true, exclusive: false }, (fileEntry) => this.manageFileEntry(fileEntry), (error) => this.manageError(error));
}
this.manageError = function (error) {
	if(this.error!=null && this.error!=undefined){
	this.error(error);
	}
} 
this.writeFile = function (fileEntry, dataObj, DNCSuccess) {
    // Create a FileWriter object for our FileEntry (log.txt).
    //console.log("writeFile", this.name);
	this.doNotCallSuccess = DNCSuccess;
    this.dataToWrite = dataObj;
    fileEntry.createWriter((fileWriter) => this.manageFileWriter(fileWriter));

}
this.manageFileWriter = function (fileWriter) {
		//console.log("manageFileWriter", this.name);
	    fileWriter.onerror = (e) => this.manageError(e);
	    if(this.doNotCallSuccess !== true) {
		if(this.success!=null && this.success!=undefined){				
	    fileWriter.onwriteend = (e) => this.success(this.fileEntry.toURL());
		}
		}
        fileWriter.write(this.dataToWrite);        
}
this.resetAll = function (){
	this.name = "";	
	this.success = null;
	this.error = null;
	this.contentsOptional = null;
	// 0 = json, image = 1
	this.fileType = 0;
	this.reader = null;
	this.fileEntry = null;
	this.dataToWrite = null;
	this.returnToURL = false;
	this.writingOp = false;
	this.doNotCallSuccess = false;
}
	
	};
